import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash'
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { DatePicker } from "@material-ui/pickers";
import { timeObj, timeStr } from "./utils"
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles(theme => ({
    formControl: {
        width: "100%"
    },
    option: {
        whiteSpace: "normal"
    },
    radio_title: {
        paddingBottom: theme.spacing(1.5),
        color: '#000',
        lineHeight: '1.5'
    },
    error: {
        color: 'red'
    },
    resize:{
        fontSize:"30px"
    }
}));


const CustomSelect = (props) => {

    const classes = useStyles(props);

    const inputLabel = React.useRef(null);

    const [labelWidth, setLabelWidth] = React.useState(0);

    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const handleChange = (field) => (e) => {
        props.handleSelectChange(field, e.target.value)
    }

    return (
        <Grid item xs={props.width}>
            <FormControl fullWidth variant="outlined" htmlFor={props.field}>
                <InputLabel id={props.field} ref={inputLabel}>{props.placeHolder}</InputLabel>
                <Select
                    native
                    inputProps={{
                        id: props.field,
                        name: props.field
                    }}
                    labelWidth={labelWidth}
                    value={props.value}
                    onChange={handleChange(props.field)}
                    fullWidth
                    placeholder={props.placeHolder}
                    error={props.error}
                    disabled={props.disabled}
                >
                    <option value="" />
                    {_.map(props.options, (item, key) => {
                        return <option value={item.value} key={key} className={classes.option}>{item.label}</option>
                    })}
                </Select >
            </FormControl>
        </Grid>
    )
}

const CustomInput = (props) => {

    const classes = useStyles(props);

    const handleChange = (field) => (e) => {
        props.handleSelectChange(field, e.target.value)
    }

    return (
        <Grid item xs={props.width}>
            <FormControl className={classes.formControl}>
                <TextField
                    id={props.field}
                    value={props.value}
                    onChange={handleChange(props.field)}
                    fullWidth
                    label={props.placeHolder}
                    disabled={props.disabled}
                    error={props.error}
                    InputLabelProps={{style: {fontSize: 20}}}
                />
            </FormControl>
        </Grid>
    )
}



const CustomCheckbox = (props) => {

    const classes = useStyles(props);

    const handleChange = (field) => (e) => {

        props.handleSelectChange(field, e.target.checked)
    }

    return (
        <FormControlLabel
            control={
                <Checkbox checked={props.value} onChange={handleChange(props.field)} value={props.field} />
            }
            label={props.label}
        />
    )
}

const CustomDatePicker = (props) => {

    const classes = useStyles(props);

    const handleChange = (field) => (value) => {

        if (value) {
            props.handleSelectChange(field, timeStr(value))
        } else {
            props.handleSelectChange(field, "")
        }

    }

    return (
        <Grid item xs={props.width}>
            <FormControl className={classes.formControl}>
                <DatePicker
                    label={props.label}
                    value={props.value ? timeObj(props.value) : null}
                    onChange={handleChange(props.field)}
                    format="yyyy/MM/dd"
                    disabled={props.disabled}
                    disablePast={props.disablePast}
                    error={props.error}
                    minDate={props.minDate ? props.minDate : new Date('1900/01/01')}
                    maxDate={props.maxDate ? props.maxDate : new Date('2100/01/01')}
                    openTo={props.openTo ? props.openTo : "date"}
                    InputLabelProps={{style: {fontSize: 20}}}
                />
            </FormControl>
        </Grid>
    )
}


const CustomRadioGroup = (props) => {

    const classes = useStyles(props);

    const handleChange = (field) => (e) => {
        props.handleSelectChange(field, e.target.value)
    }

    return (
        <Grid item xs={12}>
            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend" className={`${classes.radio_title} ${props.error ? classes.error : ``}`}>{props.label}</FormLabel>
                <RadioGroup aria-label={props.field} name={props.field} value={props.value} onChange={handleChange(props.field)}>
                    <FormControlLabel value="Y" control={<Radio />} label="是" />
                    <FormControlLabel value="N" control={<Radio />} label="否" />
                </RadioGroup>
            </FormControl>
        </Grid>
    )
}


export { CustomSelect, CustomInput, CustomCheckbox, CustomDatePicker, CustomRadioGroup }